import * as React from "react";
import {IQuestionMessageBodyProps} from "./~types/QuestionMessageBodyProps";
import { botTextToComponentWithLinks } from "src/app/shared/helpers/weblinks-helper/WeblinksHelper";

export default class QuestionMessageBody extends React.Component<IQuestionMessageBodyProps> {
    public render() {
        return botTextToComponentWithLinks(this.props.questionMessage.questionText);
    }
}
